{
    "SectionheaderDatetime": "Date \/ Heure",
    "SectionheaderTimerange": "Plage de temps",
    "SectionheaderDaterange": "Plage de dates\/heures personnalisée",
    "SectionheaderDaysoftheweek": "Jours de la semaine",
    "InputlabelBetween": "Entre :",
    "InputlabelAnd": "Et :",
    "RadiolabelRealtime": "En temps réel (maintenant)",
    "RadiolabelToday": "Aujourd'hui",
    "RadiolabelYesterday": "Hier",
    "RadiolabelThisweek": "Cette semaine",
    "RadiolabelLastweek": "La semaine dernière",
    "RadiolabelThismonth": "Ce mois-ci",
    "RadiolabelLastmonth": "Le mois dernier",
    "RadiolabelCustom": "Personnalisé...",
    "RadiolabelDays": "Jours :",
    "NAME": "DateTime",
    "SectionHeaderLastXDays": "Derniers \"X\" jours",
    "RadiolabelLastXDays": "Derniers \"X\" jours"
}